export function routes($stateProvider) {
  $stateProvider
    .state('app', {
      template: require('./layout/layout.view.html'),
      controller: 'LayoutController',
      controllerAs: 'vm'
    })
    .state('auth', {
      template: '<div class="loginBg" ui-view></div>'
    })
    .state('app.dashboard', {
      template: require('./dashboard/dashboard.view.html'),
      url: '/?page&count&sort&filter&group',
      title: 'Dashboard',
      controller: 'DashboardController',
      controllerAs: 'vm',
      role: '$authenticated'
    })
    .state('app.profile', {
      template: require('./profile/profile.view.html'),
      url: '/profile',
      title: 'Perfil',
      controller: 'ProfileController',
      controllerAs: 'vm',
      role: '$authenticated'
    })
    .state('app.changelog', {
      url: '/changelog',
      abstract: true,
      template: '<ui-view></ui-view>'
    })
    .state('app.changelog.view', {
      template: require('./changelog/changelog.view.html'),
      url: '/',
      params: {
        version: undefined,
        expanded: false,
      },
      title: 'Changelog',
      controller: 'ChangelogController',
      controllerAs: 'vm',
      role: '$authenticated'
    })
  ;
}

routes.$inject = ['$stateProvider'];
